module.exports = __webpack_public_path__ + "static/media/mappa-contatti-truccheria.06a3efd4.png";